import { numberToPaddedHex } from '@multiversx/sdk-core/out/utils.codec';
import BigNumber from 'bignumber.js';

export const convertWeiToEsdt = (amount: BigNumber.Value, decimals?: number, precision?: number): BigNumber => {
    if (!amount) amount = '0';
    return BigNumber(amount).shiftedBy(decimals == null ? -18 : -decimals).decimalPlaces(precision == null ? 4 : precision, BigNumber.ROUND_FLOOR);
};

export const convertEsdtToWei = (amount: BigNumber.Value, decimals?: number): BigNumber => {
    if (!amount) amount = '0';
    return BigNumber(amount).shiftedBy(decimals == null ? 18 : decimals).decimalPlaces(0, BigNumber.ROUND_FLOOR);
};

export const createNftId = (collection_id: string, nft_nonce: number) => {
    return `${collection_id}-${numberToPaddedHex(nft_nonce)}`;
};

export const getCollectionId = (collection_id: string) => {
    const collectionTickers = collection_id.split('-');
    let collectionId = '';
    if (collectionTickers[0]) {
        collectionId += collectionTickers[0].toUpperCase();
    }
    if (collection_id.includes('-')) {
        collectionId += '-';
    }
    if (collectionTickers[1]) {
        collectionId += collectionTickers[1].toLocaleLowerCase();
    }
    return collectionId;
};

export const getTokenTicker = (tokenId: string) => {
    if (tokenId.includes('-')) {
        const tokenTicker = tokenId.split('-')[0];
        return tokenTicker;
    } else {
        return tokenId;
    }
};

export const getTokenDecimal = (tokenId: string) => {
    if (tokenId === 'EGLD') {
        return 18;
      }
    
      if (tokenId.includes('-')) {
        const tokenTicker = tokenId.split('-')[0];
    
        if (tokenTicker === 'WEGLD') return 18;
        if (tokenTicker === 'USDT') return 6;
        if (tokenTicker === 'USDC') return 6;
        if (tokenTicker === 'BUSD') return 18;
        if (tokenTicker === 'ASH') return 18;
      }
};